import plyr from 'plyr';

module.exports = Backbone.mixin(Backbone.View.extend({
  template: require('./template.hbs'),
  displayDelay: 500,
  data: {
    title: '',
    sub_title: null,
    content: '',
    button: 'fa fa-info'
  },

  toggle: function (value) {
    _.delay(_.bind(this._toggle, this, value), this.displayDelay);
  },

  _toggle: function (value) {
    this.$el.toggleClass('show', value);
    this.trigger('toggle', this.$el.hasClass('show'));
  },

  initialize: function () {
    _.bindAll(this, 'toggle');
    this.$el.addClass('helper');
  },

  render: function (data) {
    data = _.extend({}, this.data, data);
    this.$el.html(this.template(data));
    this.setElementStyle();
  },

  setElementStyle: function () {
    const $toolContent = this.$el.closest('.tool-content');

    const width = $toolContent.outerWidth();
    const height = $toolContent.outerHeight();
    const contentOffset = $toolContent.offset();

    this.$el.addClass('helper').css({
      height: height + 'px',
      width: width + 'px'
    });

    this.$el.find('.helper-content').css({
      height: height + 'px',
      width: width + 'px'
    });
  },

  openVideoContent: function (videoId, options) {
    options = options || {};
    INKIVE.Modal.modalWindow(
      '<div class="plyr-player" data-type="youtube" data-video-id="' + videoId + '"></div>',
      _.extend({ headerTitle: 'general.close' }, options)
    );

    plyr.setup(document.querySelector('.plyr-player'), { controls: [] });
  }
}), Backbone.Events);
